import type { monaco } from 'react-monaco-editor';

const monacoThemeLight: monaco.editor.IStandaloneThemeData = {
  base: 'vs',
  inherit: true,
  rules: [
    {
      foreground: '2a5a8a',
      token: 'punctuation - (punctuation.definition.string || punctuation.definition.comment)',
    },
    {
      foreground: 'c41e54',
      token: 'constant',
    },
    {
      foreground: 'b8a600',
      token: 'entity',
    },
    {
      foreground: 'cc7300',
      token: 'keyword',
    },
    {
      foreground: 'a89500',
      token: 'storage',
    },
    {
      foreground: '2a9500',
      token: 'string -string.unquoted.old-plist -string.unquoted.heredoc',
    },
    {
      foreground: '2a9500',
      token: 'string.unquoted.heredoc string',
    },
    {
      foreground: '0066cc',
      token: 'comment',
      fontStyle: 'italic',
    },
    {
      foreground: '009966',
      token: 'support',
    },
    {
      foreground: '555555',
      token: 'variable',
    },
    {
      foreground: 'cc0099',
      token: 'variable.language',
    },
    {
      foreground: 'a89500',
      token: 'meta.function-call',
    },
    {
      // FLIPPED: background becomes foreground, foreground becomes background
      foreground: '800f00',
      background: 'f8f8f8',
      token: 'invalid',
    },
    {
      // FLIPPED
      foreground: '800f00',
      background: 'f8f8f8',
      token: 'string.invalid',
    },
    {
      // FLIPPED
      foreground: '800f00',
      background: 'f8f8f8',
      token: 'string.escape.invalid',
    },
    {
      // FLIPPED: dark text on light background
      foreground: '223545',
      background: 'f8f8f8',
      token: 'text source',
    },
    {
      // FLIPPED
      foreground: '223545',
      background: 'f8f8f8',
      token: 'string.unquoted.heredoc',
    },
    {
      // FLIPPED
      foreground: '223545',
      background: 'f8f8f8',
      token: 'source source',
    },
    {
      foreground: '0099cc',
      fontStyle: 'italic',
      token: 'entity.other.inherited-class',
    },
    {
      foreground: '5fb300',
      token: 'string.quoted source',
    },
    {
      foreground: '00b300',
      token: 'string constant',
    },
    {
      foreground: '00a676',
      token: 'string.regexp',
    },
    {
      foreground: 'b39b00',
      token: 'string variable',
    },
    {
      foreground: 'cc7a00',
      token: 'support.function',
    },
    {
      foreground: 'b54d5a',
      token: 'support.constant',
    },
    {
      foreground: 'cc1600',
      token: 'support.type.exception',
    },
    {
      foreground: '5f6c7e',
      token: 'meta.preprocessor.c',
    },
    {
      foreground: '7a8ea8',
      token: 'meta.preprocessor.c keyword',
    },
    {
      foreground: '4a5553',
      token: 'meta.sgml.html meta.doctype',
    },
    {
      foreground: '4a5553',
      token: 'meta.sgml.html meta.doctype entity',
    },
    {
      foreground: '4a5553',
      token: 'meta.sgml.html meta.doctype string',
    },
    {
      foreground: '4a5553',
      token: 'meta.xml-processing',
    },
    {
      foreground: '4a5553',
      token: 'meta.xml-processing entity',
    },
    {
      foreground: '4a5553',
      token: 'meta.xml-processing string',
    },
    {
      foreground: '008899',
      token: 'meta.tag',
    },
    {
      foreground: '008899',
      token: 'meta.tag entity',
    },
    {
      foreground: '008899',
      token: 'meta.selector.css entity.name.tag',
    },
    {
      foreground: 'cc7e00',
      token: 'meta.selector.css entity.other.attribute-name.id',
    },
    {
      foreground: '3aa030',
      token: 'meta.selector.css entity.other.attribute-name.class',
    },
    {
      foreground: '4d9d4f',
      token: 'support.type.property-name.css',
    },
    {
      foreground: 'b3a000',
      token: 'meta.property-group support.constant.property-value.css',
    },
    {
      foreground: 'b3a000',
      token: 'meta.property-value support.constant.property-value.css',
    },
    {
      foreground: 'c67700',
      token: 'meta.preprocessor.at-rule keyword.control.at-rule',
    },
    {
      foreground: 'b3a000',
      token: 'meta.property-value support.constant.named-color.css',
    },
    {
      foreground: 'b3a000',
      token: 'meta.property-value constant',
    },
    {
      foreground: 'b54d5a',
      token: 'meta.constructor.argument.css',
    },
    {
      foreground: '000e1a',
      background: 'f8f8f8',
      token: 'meta.diff',
    },
    {
      foreground: '000e1a',
      background: 'f8f8f8',
      token: 'meta.diff.header',
    },
    {
      foreground: '4c0900',
      background: 'ffeaea',
      token: 'markup.deleted',
    },
    {
      foreground: '806f00',
      background: 'fffacc',
      token: 'markup.changed',
    },
    {
      foreground: '154f00',
      background: 'e6ffe6',
      token: 'markup.inserted',
    },
    {
      background: 'e6f7ff',
      token: 'markup.raw',
    },
    {
      background: 'e6f2ff',
      token: 'markup.quote',
    },
    {
      background: 'f5f3ff',
      token: 'markup.list',
    },
    {
      foreground: '6d4dcc',
      fontStyle: 'bold',
      token: 'markup.bold',
    },
    {
      foreground: '00a676',
      fontStyle: 'italic',
      token: 'markup.italic',
    },
    {
      foreground: '0066b3',
      background: 'f0f8ff',
      fontStyle: 'bold',
      token: 'markup.heading',
    },
  ],
  colors: {
    focusBorder: '#09090A00', // force transparent border
    'editor.foreground': '#09090A', // content.text.on.color.light.dark
    'editor.background': '#f5f5f5',
    'editor.selectionBackground': '#B3653980',
    'editor.lineHighlightForeground': '#09090AB2', // color.content.neutral[2]
    'editor.lineHighlightBackground': '#F5F5F5',
    'editorLineNumber.foreground': '#09090A80', // color.content.neutral[3]
    'editorCursor.foreground': '#000000',
    'editorWhitespace.foreground': '#CCCCCC',
    'editorInlayHint.background': '#F0F0F0',
  },
};

export default monacoThemeLight;
